import React, { useState } from 'react';
import StatisticFilter from './StatisticFilter';
import StatisticGames from './StatisticGames';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import { Stack } from '@mui/material';

export default function SettingGameStatistic() {
  const [loader, setLoader] = useState(false);
  const [empty, setEmpty] = useState(false);

  return (
    <CusPageCardContainer title="Game statistics">
      <Stack gap={2}>
        <StatisticFilter setLoader={setLoader} setEmpty={setEmpty} />
        <StatisticGames loader={loader} empty={empty} />
      </Stack>
    </CusPageCardContainer>
  );
}
